import { Dispatch, FC, SetStateAction } from 'react';
import { IYupSchema, yupSchemas, STEPS } from '../../consts';
import { useFormApi, useMultistepApi } from 'informed';
import { ArrowLeftIcon, ArrowRightIcon, SuccessIcon } from '@assets/svg';
import css from './styles.module.scss';
import { Button } from '@components';

interface NavigationProps {
  setYupSchema: Dispatch<SetStateAction<IYupSchema>>;
  isNew?: boolean;
}

const Navigation: FC<NavigationProps> = ({ setYupSchema, isNew = true }) => {
  const { getFormState } = useFormApi();
  const { next, previous, getCurrentStep, getNextStep, getPreviousStep } = useMultistepApi();

  const currentStep = getCurrentStep();
  const prevStep = getPreviousStep();
  const nextStep = getNextStep() as unknown as string;

  const onPrev = () => {
    previous();
    setYupSchema(yupSchemas[prevStep]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onNext = () => {
    next();
    const { valid } = getFormState();
    if (valid) setYupSchema(yupSchemas[nextStep]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={css.navigation}>
      {currentStep !== STEPS.DETAILS ? (
        <Button
          text='Back'
          iconL={<ArrowLeftIcon />}
          className={`${css.button} ${css.buttonPrev}`}
          onClick={onPrev}
          type='button'
          variant='transparent'
        />
      ) : null}
      {currentStep !== STEPS.REVIEW ? (
        <Button
          text='Save and go next'
          iconR={<ArrowRightIcon />}
          className={`${css.button} ${css.buttonNext}`}
          onClick={onNext}
          type='button'
        />
      ) : (
        <Button
          text={isNew ? 'Submit and create workshop' : 'Submit and update workshop'}
          iconR={<SuccessIcon />}
          type='submit'
          variant='forest'
          className={`${css.button} ${css.buttonConfirm}`}
        />
      )}
    </div>
  );
};

export default Navigation;
